import { render } from "./StepPayOrderInfo.vue?vue&type=template&id=60283a34"
import script from "./StepPayOrderInfo.vue?vue&type=script&lang=js"
export * from "./StepPayOrderInfo.vue?vue&type=script&lang=js"

import "./StepPayOrderInfo.vue?vue&type=style&index=0&id=60283a34&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__